module.exports = __webpack_public_path__ + "static/img/mainMockupLeft.820a382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/mainMockupLeft.png
// module id = OFN0
// module chunks = 0